import { TypedUseSelectorHook, useSelector } from 'react-redux';

import type { RootState } from 'prequalificationV2/actions/index';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
